import { NavLink } from 'react-router';
import { PageWrapper } from '../../components/PageWrapper';
import './outputs.css';

export function Outputs() {
  return (
    <PageWrapper>
      <h2>Outputs</h2>
      <p>
        Every calculator generates a set of emissions results when it runs. The output from each calculator is
        different, but they all follow a similar format and structure. You can see the exact shape of the output of a
        calculator by looking at the <NavLink to="../api-reference">API reference</NavLink> or{' '}
        <NavLink to="../sdk">Package API reference</NavLink>.
      </p>
      <h3>Output Format</h3>
      <p>This section offers a high level description of the keys that are common to all calculator outputs.</p>
      <h4>scope1, scope2, scope3</h4>
      <p>
        Each object contains the emissions results for a given scope. Each result is in the unit of tonnes-CO2e. They
        also include a total emissions result for the scope. Scope 1 will include emissions for different greenhouse
        gasses, where scope 2 and 3 are just in tonnes-CO2e.
      </p>
      <h4>net</h4>
      <p>
        The net emissions result is the sum of the scope 1, scope 2, and scope 3 emissions. Some calculators may support
        other considerations like carbon sequestration or purchased offsets.
      </p>
      <h4>intermediate</h4>
      <p>
        Every calculator accepts a list of top level 'activities', which define most of the detailed inputs for the
        calculator. The intermediate output is the emissions for each of these individual activities. You can supply an
        optional `id` field for each activity to identify it in the output. If you don't supply an id, the activity will
        be generated a unique id, based on the order of the activities in the input. Each intermediate result will have
        keys very similar to the top level emissions result. For example, they will include the same keys for scopes,
        net and intensities, but the results in each of these keys will be just for the specific activity.
      </p>
      <p>The top level results are always the sum of all intermediate results provided in the output.</p>
      <h4>intensities</h4>
      <p>
        Each calculator will accept inputs for the amount of material, meat, grain etc produced. The intensities keys
        give you a result for the emissions intensity for producing one unit of productive output. Some calculators may
        have multiple intensity values, like meat and wool for sheep.
      </p>
      <p>The intensities will generally be offered with and without carbon sequestration.</p>
      <h4>carbonSequestration</h4>
      <p>
        Some calculators will accept inputs to describe carbon sequestration. The carbon sequestration result will be in
        tonnes-CO2e. It is already considered in the intensities and net results.
      </p>
    </PageWrapper>
  );
}
